import { render, staticRenderFns } from "./Alert02.vue?vue&type=template&id=56d344e6&scoped=true&"
import script from "./Alert02.vue?vue&type=script&lang=js&"
export * from "./Alert02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d344e6",
  null
  
)

export default component.exports